import { type ComponentProps, type FC } from 'react';

import { Grid } from '@eneco/sparky';
import { getClassNames } from '@eneco/sparky/util/css';

import {
  navigationViewFirstItemClass,
  navigationViewGridClass,
  navigationViewSecondItemClass,
} from './NavigationView.css';

export const NavigationViewGrid: FC<Omit<ComponentProps<typeof Grid>, 'className'> & { className?: string }> = ({
  className,
  ...rest
}) => (
  <Grid
    {...({ ...rest, className: getClassNames(navigationViewGridClass, className) } as unknown as ComponentProps<
      typeof Grid
    >)}
  />
);

NavigationViewGrid.displayName = 'NavigationViewGrid';

export const NavigationViewFirstItem: FC<
  Omit<ComponentProps<typeof Grid.Item>, 'className'> & { className?: string }
> = ({ className, ...rest }) => (
  <Grid.Item
    {...({ ...rest, className: getClassNames(navigationViewFirstItemClass, className) } as unknown as ComponentProps<
      typeof Grid.Item
    >)}
  />
);

NavigationViewFirstItem.displayName = 'NavigationViewFirstItem';

export const NavigationViewSecondItem: FC<
  Omit<ComponentProps<typeof Grid.Item>, 'className'> & { className?: string }
> = ({ className, ...rest }) => (
  <Grid.Item
    {...({ ...rest, className: getClassNames(navigationViewSecondItemClass, className) } as unknown as ComponentProps<
      typeof Grid.Item
    >)}
  />
);

NavigationViewSecondItem.displayName = 'NavigationViewSecondItem';
